/**
 * Estado de una cuenta de empresa — REQ-CTA-004.
 *
 * `cat_cuentas_empresa.activo` is a TINYINT with THREE states since S1:
 *   1 = activa, 2 = inactiva, 0 = eliminada.
 *
 * Never test it for truthiness. `activo = 2` is truthy and the account is NOT active —
 * that is exactly how the old view painted inactive accounts green as "Activa".
 */

export const ESTADO_CUENTA = {
  ELIMINADA: 0,
  ACTIVA: 1,
  INACTIVA: 2,
};

const ETIQUETAS = {
  [ESTADO_CUENTA.ACTIVA]: 'Activa',
  [ESTADO_CUENTA.INACTIVA]: 'Inactiva',
  [ESTADO_CUENTA.ELIMINADA]: 'Eliminada',
};

const COLORES = {
  [ESTADO_CUENTA.ACTIVA]: 'success',
  [ESTADO_CUENTA.INACTIVA]: 'warning',
  [ESTADO_CUENTA.ELIMINADA]: 'error',
};

// The API may serialise the TINYINT as a string, so normalise before looking up.
// Returns null for null/undefined instead of coercing them to 0 (= eliminada).
const normalizar = (activo) => (activo == null ? null : Number(activo));

export const etiquetaEstadoCuenta = (activo) => ETIQUETAS[normalizar(activo)] ?? '—';

export const colorEstadoCuenta = (activo) => COLORES[normalizar(activo)] ?? 'grey';

export const esCuentaActiva = (activo) => normalizar(activo) === ESTADO_CUENTA.ACTIVA;

export const OPCIONES_ESTADO_CUENTA = [
  { text: 'Activas', value: ESTADO_CUENTA.ACTIVA },
  { text: 'Inactivas', value: ESTADO_CUENTA.INACTIVA },
  { text: 'Eliminadas', value: ESTADO_CUENTA.ELIMINADA },
];
